/**
 * SURVEY-MOVE-ACCOUNT.MODAL
 * Change account for the survey
 */
import { WithTranslation, withTranslation } from "react-i18next"
import { connect } from "react-redux"
import Modal from "@/components/modal"
import { SurveyState } from "@/redux/survey.types"
import TextInput from "@/components/text-input"
import { useState } from "react"
import { Account } from "@/redux/account.types"
import ListButton from "@/components/list-button"
import { faSearch, faShieldAlt } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import LoadingModal from "./loading.modal"
import { store } from "@/core/root-reducer"
import { accountFetch } from "@/redux/account.actions"
import ListItem from "@/components/list-item"
import ListIcon from "@/components/list-icon"
import { getIconUrl } from "@/utils/default-icons.utils"
import { surveyMove } from "@/redux/survey.actions"
import { getImageUrl } from "@/utils/get-image-url"

interface StateProps extends WithTranslation {
  survey: SurveyState
}

interface OwnProps {
  onClose: Function
}

type Props = StateProps & OwnProps

function SurveyMoveAccountModal(props: Props) {
  const [accounts, setAccounts] = useState<Account[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [selectedAccount, setSelectedAccount] = useState<Account | null>(null)

  async function handleSearch() {
    setIsLoading(true)
    const response: any = await store.dispatch(accountFetch(search))
    if (!response.error) {
      setAccounts(response.map((x) => new Account(x)))
    }
    setIsLoading(false)
  }

  async function handleNext() {
    if (!selectedAccount) {
      toast("Aucun compte n'a été sélectionné", { type: "error" })
    } else {
      setIsLoading(true)
      const response: any = await store.dispatch(surveyMove(props.survey.active.id, selectedAccount.id))
      setIsLoading(false)
      if (!response.error) {
        alert("Opération effectuée")
        props.onClose()
      }
    }
  }

  return (
    <Modal
      isCloseButtonVisible
      title="Déplacer l'enquête dans un autre compte"
      onClose={() => props.onClose()}
      onNext={() => handleNext()}>
      {isLoading && <LoadingModal />}
      <div className="flex">
        <TextInput value={search} onChange={(e) => setSearch(e.value)} title="Rechercher un compte" />
        <div className="mt-[54px]">
          <ListButton icon={faSearch} isFat onClick={() => handleSearch()} />
        </div>
      </div>
      <div className="mt-20" />
      {accounts.map((account) => (
        <ListItem
          key={account.id}
          isSmall
          isEditable
          onClick={() => setSelectedAccount(account)}
          isActive={account.id === selectedAccount?.id}>
          <ListIcon
            fallbackIcon={faShieldAlt}
            iconColor={account.colors.brandPrimary}
            image={
              account.options.image
                ? getImageUrl("Accounts", account.id)
                : getIconUrl(account.options.defaultIcon)
            }
          />
          {account.name}
        </ListItem>
      ))}
      <div className="mt-20" />
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(SurveyMoveAccountModal))
